export default __webpack_public_path__ + "static/media/icons8-github.52038f70.svg";